{
	"name": "free-to-x-pricing-dashboard-fe",
	"version": "1.3.0",
	"scripts": {
		"ng": "ng",
		"dev": "ng serve --configuration=local",
		"start": "ng serve --configuration=local",
		"start:local": "ng serve --configuration=local",
		"start:staging": "ng serve --configuration=staging",
		"start:development": "ng serve --configuration=development",
		"start:quality": "ng serve --configuration=quality",
		"start:production": "ng serve --configuration=production",
		"test": "ng test",
		"watch": "ng build --watch --configuration=local",
		"build": "ng build --configuration=quality",
		"build:local": "ng build --configuration=local",
		"build:staging": "ng build --configuration=staging",
		"build:development": "ng build --configuration=development",
		"build:quality": "ng build --configuration=quality",
		"build:production": "ng build --configuration=production",
		"build:env": "node ./build-env.js",
		"lint": "npx eslint . --fix",
		"format": "prettier --write src/",
		"lint-format": "run-s lint format",
		"libs-reload": "rm -rf node_modules pnpm-lock.yaml && pnpm install"
	},
	"private": true,
	"dependencies": {
		"@angular/animations": "^21.0.7",
		"@angular/common": "^21.0.7",
		"@angular/compiler": "^21.0.7",
		"@angular/core": "^21.0.7",
		"@angular/forms": "^21.0.7",
		"@angular/platform-browser": "^21.0.7",
		"@angular/platform-browser-dynamic": "^21.0.7",
		"@angular/router": "^21.0.7",
		"@ngx-translate/core": "^17.0.0",
		"@ngx-translate/http-loader": "^17.0.0",
		"@primeng/themes": "^20.4.0",
		"@types/node": "^24.10.13",
		"angular-auth-oidc-client": "21.0.1",
		"angular-svg-icon": "^19.1.1",
		"axios": "^1.13.5",
		"dayjs": "^1.11.19",
		"file-saver": "^2.0.5",
		"jwt-decode": "^4.0.0",
		"lodash": "^4.17.23",
		"primeicons": "^7.0.0",
		"primeng": "^20.4.0",
		"rxjs": "~7.8.2",
		"tslib": "^2.8.1",
		"zone.js": "~0.16.0"
	},
	"devDependencies": {
		"@angular-devkit/build-angular": "^21.0.5",
		"@angular/cli": "^21.0.5",
		"@angular/compiler-cli": "^21.0.7",
		"@eslint/js": "~9.39.2",
		"@tailwindcss/postcss": "^4.2.1",
		"@types/file-saver": "^2.0.7",
		"@types/lodash": "^4.17.24",
		"angular-eslint": "^21.1.0",
		"autoprefixer": "^10.4.24",
		"dotenv": "^17.3.1",
		"eslint": "^9.39.2",
		"npm-run-all2": "^8.0.4",
		"postcss": "^8.5.6",
		"prettier": "^3.8.1",
		"prettier-plugin-tailwindcss": "^0.7.2",
		"semver": "^7.8.2",
		"tailwindcss": "^4.2.1",
		"tailwindcss-primeui": "^0.6.1",
		"typescript": "~5.9.3",
		"typescript-eslint": "~8.48.1"
	},
	"pnpm": {
		"onlyBuiltDependencies": [
			"@parcel/watcher",
			"@tailwindcss/oxide",
			"esbuild",
			"lmdb",
			"msgpackr-extract"
		],
		"overrides": {
			"node-forge": ">=1.3.2",
			"qs@<6.14.1": ">=6.14.1",
			"hono": ">=4.11.4",
			"undici@>=7.0.0 <7.18.2": ">=7.18.2"
		}
	}
}